<template>
  <div class="wrap">
    <div class="search-wrap container-box">
      <a-form-model ref="searchRef" :model="searchForm" layout="inline">
        <a-form-model-item label="用户名称" prop="nickName">
          <a-input v-model="searchForm.nickName" placeholder="请输入账号名称" />
        </a-form-model-item>
        <a-form-model-item label="联系电话" prop="phone">
          <a-input v-model="searchForm.phone" placeholder="请输入联系电话" />
        </a-form-model-item>
        <a-form-model-item>
          <a-button @click="onSearch" type="primary" style="margin-right: 20px"
            >搜索</a-button
          >
          <a-button @click="reset">重置</a-button>
        </a-form-model-item>
      </a-form-model>
      <a-button @click="add">添加用户</a-button>
    </div>

    <div class="table-wrap container-box" id="table-wraps-scroll">
      <a-table
        :columns="getColumns"
        :data-source="dataSource"
        :pagination="{
          ...pagination,
          showSizeChanger: false,
          showQuickJumper: false,
        }"
        @change="(pagination) => getDataList(pagination.current - 1)"
      >
        <template slot="operation" slot-scope="record">
          <div class="handle">
            <!-- <div
              style="margin-right: 8px; color: #1e96ff; cursor: pointer"
              @click="changeStatus(record)"
            >
              {{ record.infoStatus === "NORMAL" ? "禁用" : "启用" }}
            </div> -->
            <a-tooltip title="启用">
              <div
                class="icon"
                v-if="record.infoStatus === 'DISABLE'"
                @click="changeStatus(record)"
              >
                <i class="iconfont icon-qiyong"></i>
              </div>
            </a-tooltip>
            <a-tooltip title="禁用">
              <div
                class="icon"
                v-if="record.infoStatus === 'NORMAL'"
                @click="changeStatus(record)"
              >
                <i class="iconfont icon-jinyong"></i>
              </div>
            </a-tooltip>
            <a-tooltip title="编辑">
              <div class="icon" @click="edit(record)">
                <i class="iconfont icon-bianji"></i>
              </div>
            </a-tooltip>
            <a-tooltip title="删除">
              <div class="icon" @click="() => showDeleteModal(record)">
                <i class="iconfont icon-shanchu1"></i>
              </div>
            </a-tooltip>
          </div>
        </template>
      </a-table>
    </div>

    <a-modal
      class="account-modal"
      width="450px"
      :title="modalConfig.title"
      :visible="visible"
      :maskClosable="false"
      @ok="onSave"
      @cancel="handleCancel"
    >
      <a-form-model
        :labelCol="{ span: 8 }"
        :wrapperCol="{ span: 12 }"
        :rules="rules"
        ref="formRef"
        :model="formValues"
        :form="form"
      >
        <a-form-model-item label="账号" prop="userName">
          <a-input
            :disabled="modalConfig.type === 'edit'"
            v-model="formValues.userName"
            placeholder="请输入账号"
          />
        </a-form-model-item>
        <a-form-model-item label="密码" prop="memberPwd">
          <a-input
            type="password"
            v-model="formValues.memberPwd"
            placeholder="请输入密码"
          />
        </a-form-model-item>
        <a-form-model-item label="用户名称" prop="nickName">
          <a-input v-model="formValues.nickName" placeholder="请输入用户名称" />
        </a-form-model-item>
        <a-form-model-item label="联系方式" prop="phone">
          <a-input v-model="formValues.phone" placeholder="请输入联系方式" />
        </a-form-model-item>
        <a-form-model-item label="状态" prop="infoStatus">
          <a-radio-group v-model="formValues.infoStatus">
            <a-radio value="NORMAL">启用</a-radio>
            <a-radio value="DISABLE">禁用</a-radio>
          </a-radio-group>
        </a-form-model-item>
      </a-form-model>
    </a-modal>
  </div>
</template>
<script>
import { mobileRegExp } from "../../../utils/commonRegExp";
import {
  dataList,
  addUser,
  updateUserInfo,
  removeUser,
  //checkUserName,
} from "./service";
import scrollbarInit from "@/utils/perfectScrollBar";

let scrollbar = null;
export default {
  name: "",
  data() {
    return {
      form: this.$form.createForm(this),
      searchForm: {
        nickName: "",
        phone: "",
      },
      currentUser: {},
      formValues: {
        infoStatus: "NORMAL",
      },
      dataSource: [],
      getColumns: [
        {
          title: "序号",
          dataIndex: "id",
          ellipsis: true,
          align: "center",
          customRender: (text) => {
            return text || "--";
          },
        },
        {
          title: "用户名称",
          dataIndex: "nickName",
          ellipsis: true,
          align: "center",
          customRender: (text) => {
            return text || "--";
          },
        },
        {
          title: "联系电话",
          dataIndex: "phone",
          ellipsis: true,
          align: "center",
          customRender: (text) => {
            return text || "--";
          },
        },
        {
          title: "所属部门",
          dataIndex: "departmentName",
          ellipsis: true,
          align: "center",
          customRender: (text) => {
            return text || "--";
          },
        },
        {
          title: "角色",
          dataIndex: "roleName",
          ellipsis: true,
          align: "center",
          customRender: (text) => {
            return text || "--";
          },
        },
        {
          title: "账号状态",
          dataIndex: "infoStatus",
          ellipsis: true,
          align: "center",
          customRender: (text) => {
            const type = {
              NORMAL: "启用",
              DISABLE: "禁用",
            };
            return type[text] || "--";
          },
        },
        {
          title: "修改时间",
          dataIndex: "lastUpdated",
          ellipsis: true,
          align: "center",
          customRender: (text) => {
            return text || "--";
          },
        },
        {
          title: "操作",
          dataIndex: "",
          scopedSlots: { customRender: "operation" },
          ellipsis: true,
          width: 200,
        },
      ],
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0,
      },
      visible: false,
      modalConfig: {},
      modalRecord: {},
      userName: false,
    };
  },
  computed: {
    rules() {
      const tmp = {
        userName: [{ required: true, message: "请输入账号", trigger: "blur" }],
        memberPwd: [{ required: true, message: "请输入密码", trigger: "blur" }],
        nickName: [
          { required: true, message: "请输入用户姓名", trigger: "blur" },
        ],
        phone: [
          { required: true, message: "请输入联系电话", trigger: "blur" },
          {
            pattern: mobileRegExp,
            message: "手机号码格式不正确",
            trigger: "blur",
          },
        ],
        // infoStatus: [
        //   { required: true, message: "请选择账号状态", trigger: "blur" },
        // ],
      };
      return tmp;
    },
  },
  created() {
    this.getDataList();
  },
  mounted() {
    this.cresteScrollBar();
  },
  methods: {
    cresteScrollBar() {
      scrollbar = scrollbarInit("#table-wraps-scroll");
      const dom = document.querySelector("#table-wraps-scroll");
      dom.scrollTop = 0;
      scrollbar.update();
    },
    onSearch() {
      this.getDataList();
    },
    reset() {
      this.$refs.searchRef.resetFields();
      this.getDataList();
    },
    async getDataList(pageNo = 0) {
      try {
        const params = {
          pageNo,
          pageSize: this.pagination.pageSize,
        };
        let searchForm = this.searchForm;
        Object.keys(searchForm).map((key) => {
          searchForm[key] && (params[key] = searchForm[key]);
        });
        const res = await dataList.request(params);

        if (res.bizCode === 1) {
          this.dataSource = res.data.items;
          const pagination = {
            current: res.data.pageNo + 1,
            pageSize: params.pageSize,
            total: res.data.totalCount,
          };
          this.pagination = pagination;
        }
      } catch (error) {
        console.log(error);
      }
    },
    async changeStatus(record) {
      try {
        let infoStatus = "";
        if (record.infoStatus === "NORMAL") {
          infoStatus = "DISABLE";
        } else {
          infoStatus = "NORMAL";
        }
        const params = {
          id: record.id,
          infoStatus: infoStatus,
        };
        const msg = record.infoStatus === "NORMAL" ? "禁用成功" : "启用成功";

        const res = await updateUserInfo.request(params);

        if (res.bizCode === 1) {
          this.$message.success(msg, 4);
          this.getDataList();
        }
      } catch (error) {
        console.log(error);
      }
    },
    add() {
      this.visible = true;
      this.modalConfig = {
        type: "add",
        title: "添加用户",
      };
    },
    edit(record) {
      this.visible = true;
      this.modalConfig = {
        type: "edit",
        title: "修改用户",
      };
      this.formValues = {
        id: record.id,
        userName: record.userName,
        memberPwd: record.memberPwd,
        nickName: record.nickName,
        phone: record.phone,
        infoStatus: record.infoStatus,
      };
      this.currentUser = record;
    },
    async remove(record) {
      const params = {
        id: record.id,
      };
      const res = await removeUser.request(params);

      if (res.bizCode === 1) {
        this.$message.success("删除成功", 4);
        this.getDataList();
      }
    },
    async onSave() {
      try {
        const formRef = this.$refs.formRef;
        formRef.validate((valid) => {
          if (valid) {
            let formValues = this.formValues;
            if (this.currentUser.memberPwd === formValues.memberPwd) {
              delete formValues.memberPwd;
            }

            // let checkParams = {
            //   userName: formValues.userName,
            // };
            // checkUserName.request(checkParams).then((res) => {
            //   if (res.bizCode === 0) {
            //     this.$message.warning("账号不能重复");
            //   } else {
            const params = {
              ...formValues,
            };
            let requestMethod = null;
            if (this.modalConfig.type === "add") {
              requestMethod = addUser;
            } else {
              requestMethod = updateUserInfo;
            }

            requestMethod.request(params).then((result) => {
              if (result.bizCode === 1) {
                if (this.modalConfig.type === "add") {
                  this.$message.success("创建成功", 4);
                  this.handleCancel();
                } else {
                  this.$message.success("编辑成功", 4);
                  this.handleCancel();
                }
                this.getDataList();
              } else this.$message.warning(result.bizRemind, 4);
            });
          }
        });
      } catch (err) {
        console.error(err);
      }
    },
    handleCancel() {
      this.visible = false;
      // this.modalConfig = {};
      this.modalRecord = {};
      this.$refs.formRef.resetFields();
      this.formValues = {
        infoStatus: "NORMAL",
      };
    },
    showDeleteModal(record) {
      let that = this;
      this.$confirm({
        class: "delete-confirm-modal",
        title: "您确定需要删除这条内容吗？",
        content: "内容确认删除后不可恢复！",
        okText: "删除",
        okType: "primary",
        centered: true,
        width: 320,
        icon: () => (
          <a-icon type="info-circle" theme="twoTone" two-tone-color="#0F9F64" />
        ),
        onOk() {
          that.remove(record);
        },
        onCancel() {
          console.log("cancel");
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
@import url("../../../styles/common.less");
@import "../../../utils/convertPxToDesighViewport/convertPxToDesighViewport";
//.convertPxToDesighVH(20)[] .convertPxToDesighVW(20)[]
.wrap {
  // background: #ffffff;
  height: @full-page-container-height;
  // min-height: 100%;
  .search-wrap {
    padding: .convertPxToDesighVH(24) [];
    //height: .convertPxToDesighVH(80) [];
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .table-wrap {
    height: calc(100% - .convertPxToDesighVH(120) []);
    padding: .convertPxToDesighVH(24) [] .convertPxToDesighVH(24) []
      .convertPxToDesighVH(4) [] .convertPxToDesighVH(24) [];
  }
}
::v-deep.account-modal {
  > .ant-modal-wrap {
    > .ant-modal {
      > .ant-modal-content {
        > .ant-modal-body {
          padding: .convertPxToDesighVH(40) [];
          > .ant-form {
            > .ant-row {
              display: flex;
              align-items: center;
              justify-content: center;
              > .ant-col {
                display: flex;
                align-items: center;
                justify-content: flex-start;
              }
            }
          }
        }
      }
    }
  }
}
#table-wraps-scroll {
  height: calc(100% - .convertPxToDesighVH(150) []);
  overflow: hidden;
  position: relative;
}
</style>
